import React from "react";
import { Link } from "react-router-dom";
import { Gauge } from "lucide-react";
import { StatusBadge } from "./StatusBadge";
import { HealthScoreBadge } from "./HealthScoreBadge";
import { statusColors, formatKm } from "../lib/fleet";

const PLACEHOLDER =
  "https://images.unsplash.com/photo-1616363088386-31c4a8414858?crop=entropy&cs=srgb&fm=jpg&w=800&q=70";

export function VehicleCard({ vehicle, testID }) {
  const photo = vehicle.photo || PLACEHOLDER;
  const c = vehicle.status ? statusColors(vehicle.status) : null;
  return (
    <Link
      to={`/vehicles/${vehicle.id}`}
      data-testid={testID}
      className="mf-anim-in"
      style={{
        position: "relative", display: "block", textDecoration: "none",
        background: "var(--mf-bg-card)", borderRadius: 20, overflow: "hidden",
        boxShadow: "var(--mf-shadow)", color: "var(--mf-text)",
        transition: "transform 200ms cubic-bezier(0.16,1,0.3,1), box-shadow 200ms",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "var(--mf-shadow-strong)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "var(--mf-shadow)";
      }}
    >
      {c && (
        <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 4, background: c.solid, zIndex: 2 }} />
      )}
      <div style={{ width: "100%", height: 128, background: "var(--mf-bg-muted)" }}>
        <img src={photo} alt={`${vehicle.brand} ${vehicle.model}`}
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
      </div>
      <div style={{ padding: 14, display: "flex", flexDirection: "column", gap: 8 }}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 8, alignItems: "flex-start" }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: -0.2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {vehicle.brand} {vehicle.model}
            </div>
            <div style={{ marginTop: 3, fontSize: 12, fontWeight: 700, color: "var(--mf-text-secondary)", letterSpacing: 1.2 }}>
              {vehicle.plate?.toUpperCase()}
            </div>
          </div>
          {vehicle.status ? <StatusBadge status={vehicle.status} /> : null}
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6, color: "var(--mf-text-secondary)", fontSize: 14, fontWeight: 500 }}>
            <Gauge size={16} />
            <span>{formatKm(vehicle.mileage)}</span>
          </div>
          {vehicle.health && typeof vehicle.health.score === "number" && (
            <HealthScoreBadge score={vehicle.health.score} level={vehicle.health.level} size={32} testID={`vehicle-card-health-${vehicle.id}`} />
          )}
        </div>
      </div>
    </Link>
  );
}

export function VehicleCardSkeleton() {
  return (
    <div style={{
      background: "var(--mf-bg-card)", borderRadius: 20, overflow: "hidden",
      boxShadow: "var(--mf-shadow)",
    }}>
      <div style={{ width: "100%", height: 128, background: "var(--mf-bg-muted)" }} />
      <div style={{ padding: 14 }}>
        <div style={{ height: 20, width: "60%", background: "var(--mf-bg-muted)", borderRadius: 6, marginBottom: 8 }} />
        <div style={{ height: 14, width: "35%", background: "var(--mf-bg-muted)", borderRadius: 6 }} />
      </div>
    </div>
  );
}
